document.addEventListener('DOMContentLoaded', function() {
  const mobileMenu = document.getElementById('mobileMenu');
  const openButtons = document.querySelectorAll('[open-menu-mobile], [data-action="open-menu-mobile"]');
  const closeButton = mobileMenu?.querySelector('[data-menu="close"]');
  const overlay = document.querySelector('.overlay');

  if (!mobileMenu || openButtons.length === 0 || !overlay) return;

  function openMenu() {
    mobileMenu.classList.add('is-open');
    overlay.classList.add('is-visible');
    // Add overflow-hidden class to prevent body scrolling
    document.body.classList.add('overflow-hidden');
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    // Remove overflow-hidden class to re-enable body scrolling
    document.body.classList.remove('overflow-hidden');
  }

  function toggleMenu() {
    if (mobileMenu.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  openButtons.forEach(button => {
    button.addEventListener('click', toggleMenu);
  });
  
  if (closeButton) {
    closeButton.addEventListener('click', closeMenu);
  }
  
  overlay.addEventListener('click', closeMenu);

  // Close menu on escape key press
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
      closeMenu();
    }
  });
  // Submenu navigation
  document.querySelectorAll('[data-submenu-toggle]').forEach(button => {
    button.addEventListener('click', function() {
      const parentItem = this.closest('.mobile-menu-item');
      const plusIcon = this.querySelector('.plus-icon');
      const minusIcon = this.querySelector('.minus-icon');
      
      if (parentItem.classList.contains('is-open')) {
        // Close submenu
        parentItem.classList.remove('is-open');
        plusIcon.style.display = 'block';
        minusIcon.style.display = 'none';
      } else {
        // Open submenu
        parentItem.classList.add('is-open');
        plusIcon.style.display = 'none';
        minusIcon.style.display = 'block';
      }
    });
  });

  // Third level navigation
  document.querySelectorAll('[data-third-level-toggle]').forEach(button => {
    button.addEventListener('click', function() {
      const parentItem = this.closest('.mobile-submenu-item');
      const plusIcon = this.querySelector('.plus-icon');
      const minusIcon = this.querySelector('.minus-icon');
      
      if (parentItem.classList.contains('is-open')) {
        // Close third level
        parentItem.classList.remove('is-open');
        plusIcon.style.display = 'block';
        minusIcon.style.display = 'none';
      } else {
        // Open third level
        parentItem.classList.add('is-open');
        plusIcon.style.display = 'none';
        minusIcon.style.display = 'block';
      }
    });
  });
});
